export default __webpack_public_path__ + "static/caixa4-7437d20172ab95af2ba2a068f6ab2ab1.webp";